import React from "react";
import { SandboxAIProvider } from "./SandboxAIContext";
import SandboxAIFab from "./SandboxAIFab";
import SandboxAIPanel from "./SandboxAIPanel";
import "./styles.css";

// Whistle Performance brand palette drives the sandbox-ai-* accents (header, FAB,
// user bubbles, buttons) via the same --team-primary / --team-font-color vars the
// stylesheet reads. Fixed to the brand rather than per-team colours so the assistant
// always reads as a Whistle feature. #F15923 is the brand red-orange (App.css).
const BRAND_VARS = {
  "--team-primary": "#F15923",
  "--team-font-color": "#ffffff",
} as React.CSSProperties;

const SandboxAIRoot: React.FC = () => {
  return (
    <SandboxAIProvider>
      <div className="sandbox-ai-root" style={BRAND_VARS}>
        <SandboxAIFab />
        <SandboxAIPanel />
      </div>
    </SandboxAIProvider>
  );
};

export default SandboxAIRoot;
